<template>
	<mobile-card>
		<template slot="title">
			<div class="charge-card-title">
				<div class="item-name">
					{{ item.itemName }}
				</div>
				<van-popover
					v-model="showLangMenu"
					trigger="click"
					:actions="langActions"
					placement="bottom-end"
					:get-container="getContainer"
					@select="onSelectLang">
					<template #reference>
						<div class="lang-switch-btn">
							<img src="@/assets/icon/home-page/international.png" class="lang-icon" alt="lang-icon" />
							<span class="lang-text">{{ currentLangText }}</span>
						</div>
					</template>
				</van-popover>
			</div>
		</template>

		<template slot="content">
			<div class="flex-form-info">
				<div class="left">{{ pageText.range }}</div>
				<div class="right">{{ intervalName }}</div>
			</div>
			<div class="flex-form-info" v-if="item.feeMode === 5 && item.forceConnDeclareWhenCharge === 1">
				<div class="left">{{ pageText.standard }}</div>
				<div class="right">{{ declareStd.declareStdName }}</div>
			</div>
			<div class="flex-form-info">
				<div class="left">{{ item.editMoney ? pageText.pay_money : pageText.price }}</div>
				<div class="right" v-if="moneys && moneys.length > 0" style="min-width: 100px">
					<van-dropdown-menu style="float: right" active-color="#125b2f">
						<van-dropdown-item v-model="dropDownMoney" :options="moneys" />
					</van-dropdown-menu>
				</div>
				<div class="right" v-else-if="!item.editMoney && declareStd.money" style="min-width: 100px">
					<div style="float: right">{{ declareStd.money }} {{ declareStd.specUnit }}</div>
				</div>
				<div
					class="right"
					v-else-if="item.editMoney"
					style="border-bottom: 1px #dcdee0 solid; border-top: 0px; border-left: 0px; border-right: 0px">
					<!--                    <van-icon v-show="hiddenEdit" name="edit" @click="onEdit"/>-->
					<van-field
						ref="moneyRef"
						v-model="money"
						style="height: 28px; padding: 0px; float: right"
						clearable
						autofocus
						right-icon="edit"
						@click-right-icon="$refs.moneyRef.focus()"
						:placeholder="pageText.pay_money_placeholder"
						type="number"
						input-align="right"></van-field>
					<!--                    <div v-show="!hiddenEdit" class="input-border">-->
					<!--                       -->
					<!--                    </div>-->
				</div>
				<div class="right link" style="text-decoration: none" v-else>{{ money | formatMoney }}</div>
			</div>
			<div class="flex-form-info">
				<div class="left">{{ pageText.count }}</div>
				<div class="right" v-if="!item.canChangeCount">
					{{ count }}
				</div>
				<div class="right" v-else>
					<van-stepper v-model="count" step="1" integer />
				</div>
			</div>
			<div class="flex-form-info" v-if="!showRemark">
				<!--@click.prevent="showRemark=true"-->
				<div class="left link" @click.prevent="showRemark = !showRemark" style="font-size: 12px">
					{{ pageText.fee_remark }}
				</div>
			</div>
			<div class="flex-form-info" v-if="showRemark">
				<div class="left link" style="font-size: 12px" @click.prevent="showRemark = !showRemark">
					{{ pageText.fee_remark_fold }}
				</div>
			</div>
			<div class="flex-form-info" style="height: auto" v-if="showRemark">
				<div style="width: 100%">
					<van-field
						input-align="left"
						label-align="right"
						size="14px"
						class="text-field"
						v-model="itemRemark"
						rows="2"
						style="padding: 0px; margin: 0px; padding-right: 5px; text-align: right; font-size: 13px"
						autosize
						type="textarea"
						maxlength="200"
						show-word-limit
						:placeholder="pageText.fee_remark_placeholder" />
				</div>
			</div>
		</template>
	</mobile-card>
</template>
<script>
import MobileCard from 'components/mobile-card/index'
import db from 'utils/db'

export default {
	name: 'chargeCard',
	components: { MobileCard },
	props: {
		item: Object
	},
	data() {
		return {
			hiddenEdit: true,
			checked: false,
			count: 1,
			money: 0,
			dropDownMoney: '',
			sumMoney: 0,
			itemRemark: '',
			intervalId: '',
			intervalName: '',
			intervalSpecId: '',
			declareNum: '',
			showRemark: false,
			moneys: [],
			declareStd: {},
			showLangMenu: false,
			langActions: [
				{ text: '中文', value: 'zh' },
				{ text: 'English', value: 'en' }
			],
			pageText: {
				range: this.$t('qrcode_page.range'),
				standard: this.$t('qrcode_page.standard'),
				pay_money: this.$t('qrcode_page.pay_money'),
				price: this.$t('qrcode_page.price'),
				pay_money_placeholder: this.$t('qrcode_page.pay_money_placeholder'),
				count: this.$t('qrcode_page.count'),
				fee_remark: this.$t('qrcode_page.fee_remark'),
				fee_remark_fold: this.$t('qrcode_page.fee_remark_fold'),
				fee_remark_placeholder: this.$t('qrcode_page.fee_remark_placeholder')
			}
		}
	},
	watch: {
		count(newVal) {
			this.sumMoney = this.money * newVal
		},
		money() {
			this.sumMoney = this.money * this.count
		},
		dropDownMoney(newVal) {
			this.money = newVal.toString().split('#ABC#')[1]
		},
		sumMoney() {
			this.$emit('changeSumMoney', this.sumMoney)
		}
	},
	computed: {
		currentLangText() {
			const currentLang = db.get('sys.public.language.value').value() || 'zh'
			console.log('currentLangText:', currentLang)
			return currentLang === 'zh' ? '中文' : 'EN'
		}
	},
	methods: {
		moneyFormat(money) {
			return this.$options.filters.formatMoney(money)
		},
		onSelectLang(action) {
			console.log('language:', action.value)
			const selectedLang = action.value
			db.set('sys.public.language.value', selectedLang).write()
			console.log('sys.public.language.value:', db.get('sys.public.language.value').value())
			location.reload()
		},
		getParam() {
			if (this.money > 0) {
				if (this.item.feeMode === 3 && this.item.maxMoney > 0) {
					if (this.money > this.item.maxMoney) {
						this.$notify({
							type: 'warning',
							message: '最大交费金额为：' + this.moneyFormat(this.item.maxMoney) + '元。'
						})
						return
					}
				}
				let arr = []
				arr.push({
					itemId: this.item.itemId,
					itemName: this.item.itemName,
					nowMoney: this.money * this.count,
					intervalId: this.intervalId,
					intervalName: this.intervalName,
					itemCount: this.count,
					itemRemark: this.itemRemark,
					declareNum: this.declareNum
				})
				return arr
			} else {
				this.$notify({
					type: 'warning',
					message: '请输入交费金额。'
				})
			}
		},
		onEdit() {
			this.hiddenEdit = false
		},
		handleMoney(item) {
			if (item.moneys && item.moneys.length > 0) {
				this.moneys = item.moneys.map(x => {
					return {
						text: x.name + '（' + this.$options.filters.formatMoney(x.money) + '元）',
						value: x.name + '#ABC#' + x.money
					}
				})
				this.dropDownMoney = this.moneys[0].value
				// this.money = this.moneys[0].value;
				// this.sumMoney = this.moneys[0].value;
			} else {
				this.money = item.maxMoney
				this.sumMoney = item.maxMoney
			}
		},
		getContainer() {
			return document.querySelector('.charge-card-title')
		}
	},
	mounted() {
		this.$nextTick(() => {
			let item = this.item
			console.log(item)
			if (item) {
				if (item.feeMode === 1) {
					//单一标准 不可改数量
					this.money = item.itemMoney
					this.sumMoney = item.itemMoney
				} else if (item.feeMode === 2) {
					//多标准,不可改金额
					this.handleMoney(item)
				} else if (item.feeMode === 3) {
					//自填金额,不可改数量
					this.money = null
					this.sumMoney = 0
					item.editMoney = true
				} else if (item.feeMode === 5 && item.forceConnDeclareWhenCharge === 1) {
					this.declareStd = item.declareStds[0]
					// 收费申报编号
					this.declareNum = this.declareStd.declareNum
					// 关联收费标准且强制收费时按标准收费且收费标准存在，列出该区间对应的标准
					if (item.forcePayDeclareWhenCharge === 1 && this.declareStd.money) {
						// 如果是强制按照标准缴费
						item.editMoney = false
						item.canChangeCount = true
						// 默认缴费金额等于标准金额，可通过修改数量改变
						this.money = this.declareStd.money
					} else {
						item.editMoney = true
						item.canChangeCount = false
						this.money = null
					}
				} else if (item.feeMode === 5 && item.forceConnDeclareWhenCharge === 0) {
					// 收费规则为按收费申报标准收费，但收费时又不强制关联申报标准，则按照feeMode=3的情况处理，即自填金额
					this.money = null
					this.sumMoney = 0
					item.editMoney = true
					item.canChangeCount = false
				} else {
					this.handleMoney(item)
				}
				this.showContent = true
				let interval = this.item.intervals[0]
				if (interval) {
					this.intervalId = interval.intervalId
					this.intervalName = interval.intervalName
					this.intervalSpecId = interval.intervalSpecId
				}
			}
		})
	},
	created() {}
}
</script>
<style lang="scss" scoped>
.charge-card-title {
	height: 6vh;
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
	border-radius: 5px 5px 0 0;
	.item-name {
		color: #005423;
		background: #e9e9e9;
		word-break: break-all;
		overflow: hidden;
		display: -webkit-box;
		line-clamp: 2;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
		padding-right: 5px;
	}
	.lang-switch-btn {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		margin-right: -5px;
		padding: 4px 10px;
		height: 26px;
		border: 1px solid #e0e0e0;
		border-radius: 13px;
		background-color: #ffffff;
		transition: all 0.2s ease;
		cursor: pointer;
		user-select: none;
		-webkit-user-select: none;
		.lang-icon {
			width: 16px;
			height: 16px;
			margin-right: 2px;
			object-fit: contain;
		}
		.lang-text {
			font-size: 13px;
			color: #555555; /* 选用深灰色，既能看清，又不会比业务图标更抢戏 */
			font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
		}
	}
	/* 移动端点击态反馈（提升用户体验） */
	.lang-switch-btn:active {
		background-color: #f5f5f5;
		border-color: #cccccc;
		transform: scale(0.95); /* 轻轻下压的Q弹效果 */
	}
}

.flex-form-info {
	height: 38px;
	padding-top: 0px;
	display: flex;
	align-items: center;
	.left {
		min-width: 70px;
		flex: auto;
		text-align: left;
		vertical-align: center;
	}
	.right {
		flex: auto;
		text-align: right;
		text-overflow: ellipsis;
		overflow: hidden;
		white-space: nowrap;
	}
}

.text-field {
	padding-top: 0px;
	padding-right: 0px;
}
/deep/ .van-dropdown-menu__bar {
	position: relative;
	display: flex;
	background-color: #fff;
	height: auto;
	box-shadow: 0 2px 12px rgba(100, 101, 102, 0.12);
	border-bottom: 1px solid #ccc;
}
/deep/ .van-dropdown-menu__title::after {
	position: absolute;
	top: 50%;
	right: -4px;
	margin-top: -5px;
	border: 4px solid;
	border-color: transparent transparent #bec0c1 #bec0c1;
	-webkit-transform: rotate(-45deg);
	transform: rotate(-45deg);
	opacity: 0.9;
	content: '';
}
/deep/ .van-dropdown-menu__title--down::after {
	margin-top: -1px;
	-webkit-transform: rotate(135deg);
	transform: rotate(135deg);
}
/deep/ .van-dropdown-menu__title--active::after {
	border-color: transparent transparent currentColor currentColor;
}
.link {
	text-decoration: underline;
	color: #005423;
}
.mobile-card {
	/deep/ .card-content {
		display: flex;
		flex-direction: column;
		justify-content: center;
		padding: 1vh 0 1vh 0;
	}
}
/deep/ .van-checkbox__icon .van-icon {
	border-color: #ababab;
}

/deep/ .van-checkbox__label {
	color: #005423;
}

/deep/ .van-field {
	font-size: 16px;
}

/deep/ .van-field__label {
	text-align: left;
}

/deep/ .flex-form-info {
	height: 38px;
	padding-top: 0px;
}

/deep/ .van-dropdown-item__content {
	width: 90%;
	left: 5%;
}

/deep/ .van-dropdown-menu__title {
	font-size: 14px;
}

/* 1. 缩减整个气泡菜单的宽度 */
/deep/ .van-popover {
	min-width: 50px !important; /* 限制最小宽度，让它跟右上角按钮差不多宽 */
}

/* 2. 缩减每一个选项（中文、English）的内边距和高度 */
/deep/ .van-popover__action {
	width: 90px !important;
	height: 34px !important; /* 降低每个选项的高度（默认通常是 44px） */
	padding: 0 12px !important; /* 缩减左右边距 */
}

/* 3. 让选项里的文字更精致 */
/deep/ .van-popover__action-text {
	font-size: 13px !important; /* 稍微缩小一点菜单字体 */
	color: #333333 !important; /* 稍微加深文字颜色，看起来更清晰 */
}

/* 4. 消除选项之间的自带分割线或微调边框 */
/deep/ .van-popover__action-text::after {
	border-bottom-width: 1px !important;
	border-color: #f2f3f5 !important; /* 让分割线颜色更淡、更高级 */
}
</style>
